attachEvent('.footer__nav-title', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const parentElem = ev.target.closest('.footer__nav');
    const subNav = parentElem.querySelector('nav');
    parentElem.classList.toggle('is-open-menu');
    slideToggle(subNav, 300, 'block');
  }
});
const taxEuroData = document.querySelector('.tax-euro-data');
const popupProductList = document.querySelector('.cart-popup__product-list');
const popupCartEmptyEl = document.querySelector('.cart-popup__empty');
const popupCartSummeryEl = document.querySelector('.cart-popup__summery');
const popupCartFooterEl = document.querySelector('.cart-popup__footer');
const finalPricePopupEl = document.querySelector('.cart-popup__summery-total .cart-popup__summery-item-right');
const priceTaxPopupEl = document.querySelector('.cart-popup__tax-total .cart-popup__summery-item-right');
const priceWithoutTaxPopupEl = document.querySelector('.cart-popup__without-tax .cart-popup__summery-item-right');
let dataEuroSign;
let dataTax;
let formDataPopup;
if (taxEuroData) {
  dataEuroSign = taxEuroData.dataset.euro;
  dataTax = taxEuroData.dataset.tax;
}
const wishlist = document.querySelector('.wishlist');
if (wishlist) {
  const removeFromWishlist = (item) => {
    item.closest('.card').classList.add('is-removed');
    if (wishlist.querySelectorAll('.card:not(.is-removed)').length === 0) {
      wishlist.classList.add('wishlist--empty');
      wishlist.querySelector('.wishlist__empty').classList.remove('hidden');
    }
  }
  wishlist.addEventListener('click', (e) => {
    const wishlistButton = e.target.closest('.card__wishlist-button');
    if (wishlistButton) {
      removeFromWishlist(wishlistButton);
    }
  });
}

const hidePopupCartIfEmpty = () => {
  if (popupProductList.querySelectorAll('.cart-popup__product:not(.is-hidden):not(.gift)').length < 1) {
    popupProductList.classList.add('hidden');
    popupCartSummeryEl.classList.add('hidden');
    popupCartFooterEl.classList.add('hidden');
    popupCartEmptyEl.classList.remove('hidden');
    popupProductList.querySelectorAll('.cart-popup__product.gift').forEach((el) => {
      el.classList.add('is-hidden');
    });
  }
}

const updatePricesAndCartPopup = (data) => {
  finalPricePopupEl.innerText = data.total_price;
  priceWithoutTaxPopupEl.innerText = data.total_price_without_tax;
  priceTaxPopupEl.innerText = data.tax;
  popupProductList.innerHTML = data.cart_popup_html;
};

const setPriceInEuro = (text, value, extraText = '') => {
  // eslint-disable-next-line no-param-reassign
  text.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(value) + extraText;
}

// get price in euro
const getPriceInEuro = (price) => new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(price);

const debouncePopupAxios = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const newsletterForm = document.querySelectorAll('.newsletter-form form');
  if (newsletterForm) {
    newsletterForm.forEach((el) => {
      const fv = FormValidation.formValidation(el, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: {},
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) => element.closest('.newsletter-form__item,.checkbox'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      }).on('core.form.valid', () => {
        const formData = {};
        el.querySelectorAll('input, textarea, checkbox').forEach((input) => {
          formData[input.name] = input.value.trim();
        });
        grecaptcha.ready(() => {
          grecaptcha.execute(localData.captchaSiteKey, { action: formData.action }).then((token) => {
            const formDataImage = new FormData();
            if (formData.action === 'sleepingProfileEmail') {
              formDataImage.append('url', window.location.href);
            }
            formDataImage.append('action', formData.action);
            formDataImage.append('inputs', JSON.stringify(formData));
            formDataImage.append('lang', localData.lang);
            formDataImage.append('id', localData.id);
            formDataImage.append('nonce', formData.nonce);
            formDataImage.append('token', token);
            axios
              .post(localData.siteURL, formDataImage, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                if (response.status === 200 && response.data.data.url) {
                  window.location = response.data.data.url;
                } else if (response.status === 200 && response.data.data.message) {
                  // eslint-disable-next-line no-param-reassign
                  el.innerHTML = `<div>${response.data.data.message}</div>`;
                  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              })
              .catch((error) => {
                console.error(error);
              });
          });
        });
      });
    });
  }
});

// Axios add/remove item from cart
const axiosAddRemoveFromPopupCart = (parent) => {
  parent.classList.add('pointer-events-none');
  const formDataInput = new FormData();
  formDataInput.append('action', 'addRemoveFromCart');
  formDataInput.append('inputs', JSON.stringify(formDataPopup));
  formDataInput.append('id', localData.id);
  formDataInput.append('popupCart', true);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        updatePricesAndCartPopup(response.data.data);
        updateCartQuantityBadge();
        parent.classList.remove('pointer-events-none');
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// add/remove item from cart
const addRemoveItemPopup = (element, increment) => {
  const parentElem = element.closest('.cart-popup__product-middle')
  const itemPrice = parentElem.querySelector('.cart-popup__product-price');
  const amount = parentElem.querySelector('.cart-popup__product-quantity-input');
  const dataItemPrice = parseFloat(parentElem.dataset.price.replace(',', '.'));
  const currentAmount = parseInt(amount.value, 10);

  if (!increment && currentAmount === 1) {
    return;
  }

  const newAmount = increment ? currentAmount + 1 : currentAmount - 1;
  formDataPopup = {
    cart_item_key:parentElem.dataset.itemkey,
    quantity: newAmount,
    old_quantity: currentAmount,
    price: dataItemPrice
  };

  amount.value = newAmount;
  parentElem.dataset.quantity = newAmount.toString();
  if (parentElem.hasAttribute('data-regularprice')) {
    const regularPrice = parseFloat(parentElem.dataset.regularprice);
    itemPrice.innerHTML = `<s>${ getPriceInEuro(regularPrice * newAmount) }</s>${ getPriceInEuro(dataItemPrice * newAmount) }`;
  } else {
    setPriceInEuro(itemPrice,newAmount * dataItemPrice);
  }
};

const debounceAxiosAddRemovePopupCart = debouncePopupAxios((parent) => axiosAddRemoveFromPopupCart(parent));

attachEvent('.cart-popup__product-quantity-btn.add-quantity', 'click', (ev) => {
  addRemoveItemPopup(ev.target, true);
  debounceAxiosAddRemovePopupCart(ev.target.closest('.cart-popup__product-list'));
});

attachEvent('.cart-popup__product-quantity-btn.remove-quantity', 'click', (ev) => {
  addRemoveItemPopup(ev.target, false);
  debounceAxiosAddRemovePopupCart(ev.target.closest('.cart-popup__product-list'));
});

// Axios - remove from popup cart
const axiosRemoveFromPopupCart = (itemKey, parent) => {
  parent.classList.add('pointer-events-none');
  const formDataInput = new FormData();
  formDataInput.append('action', 'removeItemFromCart');
  formDataInput.append('item_key', itemKey);
  formDataInput.append('popupCart', true);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        updatePricesAndCartPopup(response.data.data);
        updateCartQuantityBadge();
        parent.classList.remove('pointer-events-none');
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// remove from popup cart
const removeFromPopupCart = (element) => {
  const parentPopupListElem = element.closest('.cart-popup__product-list');
  const parentElem = element.closest('.cart-popup__product');
  const itemDataElem = parentElem.querySelector('.cart-popup__product-middle');
  parentElem.remove();
  hidePopupCartIfEmpty();
  axiosRemoveFromPopupCart(itemDataElem.dataset.itemkey, parentPopupListElem);
};

attachEvent('.cart-popup__product-remove-btn', 'click', (ev) => {
  removeFromPopupCart( ev.target);
});

// **************************************************
// Scroll to top
// **************************************************

const topButton = document.querySelector('.top-button');
if (topButton) {
  topButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.body.scrollIntoView({ behavior: 'smooth' }, true);
  });

  document.addEventListener('scroll', () => {
    const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
    topButton.classList.toggle('is-active', topOffset > 300);
  });

}

// **************************************************
// Prize game
// **************************************************
const axiosPrizeGameSeen = () => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'setPrizeGameSession');
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

attachEvent('.prize-game-modal .modal__close', 'click', (ev) => {
  axiosPrizeGameSeen();
});
